import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const TermsOfService = ({ onBackToHome }) => {
  const { t, i18n } = useTranslation();
  const isTr = i18n.language === 'tr';

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="container mx-auto px-6 py-4">
          <button
            onClick={onBackToHome}
            className="flex items-center gap-2 text-gray-600 hover:text-blue-600 transition-colors"
            data-testid="back-to-home-btn"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>{isTr ? 'Ana Sayfaya Dön' : 'Back to Home'}</span>
          </button>
        </div>
      </div>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white py-16">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-testid="terms-title">
            {t('pages.terms.title')}
          </h1>
          <p className="text-blue-100">{t('pages.terms.lastUpdated')}: {isTr ? 'Aralık 2025' : 'December 2025'}</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-md p-8 md:p-12">
            <div className="prose prose-lg max-w-none">
              {isTr ? (
                <>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Şartların Kabulü</h2>
                  <p className="text-gray-600 mb-6">
                    CoachMeUpp platformuna ve hizmetlerine ("Hizmetler") erişerek veya bunları kullanarak, bu Hizmet Şartlarına ("Şartlar") bağlı olmayı kabul etmiş olursunuz. Bu Şartları kabul etmiyorsanız, lütfen Hizmetlerimizi kullanmayın.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Hizmetlerin Tanımı</h2>
                  <p className="text-gray-600 mb-6">
                    CoachMeUpp, liderlik koçluğu ve yetenek geliştirme için dijital bir platform sağlar. Hizmetlerimiz, organizasyonlarda liderlik gelişimini artırmak için tasarlanmış yapay zeka destekli koç eşleştirme, sanal koçluk seansları, ilerleme takibi, analitik ve ilgili araçları içerir.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Kullanıcı Hesapları</h2>
                  <p className="text-gray-600 mb-4">Hizmetlerimizin belirli özelliklerine erişmek için bir hesap oluşturmanız gerekebilir. Şunları kabul edersiniz:</p>
                  <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
                    <li>Kayıt sırasında doğru, güncel ve eksiksiz bilgi sağlamak</li>
                    <li>Şifrenizin ve hesabınızın güvenliğini korumak</li>
                    <li>Hesabınızın yetkisiz kullanımını derhal bize bildirmek</li>
                    <li>Hesabınız altında gerçekleşen tüm faaliyetler için sorumluluk kabul etmek</li>
                  </ul>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Koçluk Hizmetleri</h2>
                  <p className="text-gray-600 mb-4">Koçluk hizmetlerimizi kullanırken şunları anlar ve kabul edersiniz:</p>
                  <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
                    <li>Koçluk, terapi, danışmanlık veya herhangi bir ruh sağlığı tedavisi değildir</li>
                    <li>Koçlar, CoachMeUpp çalışanları değil, bağımsız profesyonellerdir</li>
                    <li>Sonuçlar değişebilir ve garanti edilmez</li>
                    <li>Kendi kararlarınız ve eylemleriniz için siz sorumlusunuz</li>
                    <li>Seanslar kararlaştırıldığı şekilde planlanmalı ve katılınmalıdır</li>
                  </ul>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Gizlilik</h2>
                  <p className="text-gray-600 mb-6">
                    Koçluk seansları ile ilgili katı bir gizlilik politikası uyguluyoruz. Koçluk seansları sırasında paylaşılan bilgiler, yasa gerektirmedikçe veya kendinize veya başkalarına zarar riski olmadıkça, izniniz olmadan işvereninize veya üçüncü taraflara açıklanmayacaktır.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Fikri Mülkiyet</h2>
                  <p className="text-gray-600 mb-6">
                    CoachMeUpp platformunun tüm içeriği, özellikleri ve işlevselliği, metin, grafikler, logolar, simgeler, görüntüler, ses klipleri, yazılım ve bunların derlemesi dahil ancak bunlarla sınırlı olmamak üzere, CoachMeUpp'ın veya lisans verenlerinin münhasır mülkiyetidir ve uluslararası telif hakkı, ticari marka ve diğer fikri mülkiyet yasaları ile korunmaktadır.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Kabul Edilebilir Kullanım</h2>
                  <p className="text-gray-600 mb-4">Şunları yapmamayı kabul edersiniz:</p>
                  <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
                    <li>Hizmetleri herhangi bir yasadışı amaç için kullanmak</li>
                    <li>Diğer kullanıcıları veya koçları taciz etmek, istismar etmek veya zarar vermek</li>
                    <li>Sistemlerimize yetkisiz erişim sağlamaya çalışmak</li>
                    <li>Virüs veya diğer kötü amaçlı kodlar yüklemek</li>
                    <li>Hizmetlerin düzgün çalışmasını engellemek</li>
                    <li>İçeriğimizi izinsiz kopyalamak, değiştirmek veya dağıtmak</li>
                    <li>Hizmetleri CoachMeUpp ile rekabet etmek için kullanmak</li>
                  </ul>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Ödeme Koşulları</h2>
                  <p className="text-gray-600 mb-6">
                    Siz veya organizasyonunuz ücretli Hizmetler satın alırsa, satın alma sırasında belirtilen tüm geçerli ücretleri ödemeyi kabul edersiniz. Ücretler, bu Şartlarda açıkça belirtilmedikçe veya yasa gerektirmedikçe iade edilmez. Makul bir bildirimle fiyatlandırmamızı istediğimiz zaman değiştirme hakkımızı saklı tutuyoruz.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">9. İptal ve İadeler</h2>
                  <p className="text-gray-600 mb-6">
                    Koçluk seansları ve abonelikler için iptal politikaları satın alma sırasında bildirilecektir. Genel olarak, koçluk seansları, kaybı önlemek için en az 24 saat önceden yeniden planlanmalı veya iptal edilmelidir.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Sorumluluk Sınırlaması</h2>
                  <p className="text-gray-600 mb-6">
                    Yasaların izin verdiği azami ölçüde, CoachMeUpp, Hizmetleri kullanımınızdan kaynaklanan dolaylı, arızi, özel, sonuç olarak ortaya çıkan veya cezai zararlardan veya doğrudan veya dolaylı olarak maruz kalınan kar veya gelir kaybından veya veri, kullanım, itibar veya diğer maddi olmayan kayıplardan sorumlu olmayacaktır.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Garanti Reddi</h2>
                  <p className="text-gray-600 mb-6">
                    Hizmetler, satılabilirlik, belirli bir amaca uygunluk ve ihlal etmeme zımni garantileri dahil ancak bunlarla sınırlı olmamak üzere, açık veya zımni herhangi bir garanti olmaksızın "olduğu gibi" ve "mevcut olduğu şekliyle" sağlanır. Hizmetlerin kesintisiz, güvenli veya hatasız olacağını garanti etmiyoruz.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Tazminat</h2>
                  <p className="text-gray-600 mb-6">
                    Hizmetleri kullanımınız veya bu Şartları ihlal etmenizle bağlantılı olarak ortaya çıkan tüm talep, yükümlülük, zarar, kayıp ve masraflara karşı CoachMeUpp'ı, bağlı kuruluşlarını ve ilgili yetkililerini, direktörlerini, çalışanlarını ve temsilcilerini tazmin etmeyi, savunmayı ve zararsız tutmayı kabul edersiniz.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Geçerli Hukuk</h2>
                  <p className="text-gray-600 mb-6">
                    Bu Şartlar, kanunlar ihtilafı hükümleri dikkate alınmaksızın, Türkiye Cumhuriyeti yasalarına göre yönetilecek ve yorumlanacaktır. Bu Şartlardan kaynaklanan herhangi bir anlaşmazlık, İstanbul, Türkiye mahkemelerinde çözülecektir.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">14. Şartlarda Değişiklikler</h2>
                  <p className="text-gray-600 mb-6">
                    Bu Şartları istediğimiz zaman değiştirme hakkımızı saklı tutuyoruz. Önemli değişiklikleri bu sayfada yeni Şartları yayınlayarak ve "Son güncelleme" tarihini güncelleyerek size bildireceğiz. Bu tür değişikliklerden sonra Hizmetleri kullanmaya devam etmeniz, güncellenmiş Şartları kabul ettiğiniz anlamına gelir.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">15. İletişim Bilgileri</h2>
                  <p className="text-gray-600 mb-6">
                    Bu Şartlar hakkında sorularınız varsa, lütfen bizimle iletişime geçin:
                  </p>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <p className="text-gray-700 font-semibold">CoachMeUpp</p>
                    <p className="text-gray-600">E-posta: bilgi@coachmeupp.com</p>
                    <p className="text-gray-600">Telefon: +90 533 763 53 88</p>
                    <p className="text-gray-600">Konum: Ankara, Türkiye</p>
                  </div>
                </>
              ) : (
                <>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Agreement to Terms</h2>
                  <p className="text-gray-600 mb-6">
                    By accessing or using the CoachMeUpp platform and services ("Services"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our Services.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Description of Services</h2>
                  <p className="text-gray-600 mb-6">
                    CoachMeUpp provides a digital platform for leadership coaching and talent development. Our Services include AI-powered coach matching, virtual coaching sessions, progress tracking, analytics, and related tools designed to enhance leadership development within organizations.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">3. User Accounts</h2>
                  <p className="text-gray-600 mb-4">To access certain features of our Services, you may need to create an account. You agree to:</p>
                  <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
                    <li>Provide accurate, current, and complete information during registration</li>
                    <li>Maintain the security of your password and account</li>
                    <li>Notify us immediately of any unauthorized use of your account</li>
                    <li>Accept responsibility for all activities that occur under your account</li>
                  </ul>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Coaching Services</h2>
                  <p className="text-gray-600 mb-4">When using our coaching services, you understand and agree that:</p>
                  <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
                    <li>Coaching is not therapy, counseling, or any form of mental health treatment</li>
                    <li>Coaches are independent professionals, not employees of CoachMeUpp</li>
                    <li>Results may vary and are not guaranteed</li>
                    <li>You are responsible for your own decisions and actions</li>
                    <li>Sessions should be scheduled and attended as agreed</li>
                  </ul>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Confidentiality</h2>
                  <p className="text-gray-600 mb-6">
                    We maintain strict confidentiality regarding coaching sessions. Information shared during coaching sessions will not be disclosed to your employer or third parties without your consent, except where required by law or where there is a risk of harm to yourself or others.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Intellectual Property</h2>
                  <p className="text-gray-600 mb-6">
                    All content, features, and functionality of the CoachMeUpp platform, including but not limited to text, graphics, logos, icons, images, audio clips, software, and the compilation thereof, are the exclusive property of CoachMeUpp or its licensors and are protected by international copyright, trademark, and other intellectual property laws.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Acceptable Use</h2>
                  <p className="text-gray-600 mb-4">You agree not to:</p>
                  <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
                    <li>Use the Services for any unlawful purpose</li>
                    <li>Harass, abuse, or harm other users or coaches</li>
                    <li>Attempt to gain unauthorized access to our systems</li>
                    <li>Upload viruses or other malicious code</li>
                    <li>Interfere with the proper functioning of the Services</li>
                    <li>Copy, modify, or distribute our content without permission</li>
                    <li>Use the Services to compete with CoachMeUpp</li>
                  </ul>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Payment Terms</h2>
                  <p className="text-gray-600 mb-6">
                    If you or your organization purchases paid Services, you agree to pay all applicable fees as described at the time of purchase. Fees are non-refundable except as expressly provided in these Terms or required by law. We reserve the right to change our pricing at any time with reasonable notice.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Cancellation and Refunds</h2>
                  <p className="text-gray-600 mb-6">
                    Cancellation policies for coaching sessions and subscriptions will be communicated at the time of purchase. Generally, coaching sessions should be rescheduled or cancelled at least 24 hours in advance to avoid forfeiture.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Limitation of Liability</h2>
                  <p className="text-gray-600 mb-6">
                    To the maximum extent permitted by law, CoachMeUpp shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from your use of the Services.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Disclaimer of Warranties</h2>
                  <p className="text-gray-600 mb-6">
                    The Services are provided "as is" and "as available" without warranties of any kind, either express or implied, including but not limited to implied warranties of merchantability, fitness for a particular purpose, and non-infringement. We do not warrant that the Services will be uninterrupted, secure, or error-free.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Indemnification</h2>
                  <p className="text-gray-600 mb-6">
                    You agree to indemnify, defend, and hold harmless CoachMeUpp, its affiliates, and their respective officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses arising out of or in any way connected with your use of the Services or violation of these Terms.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Governing Law</h2>
                  <p className="text-gray-600 mb-6">
                    These Terms shall be governed by and construed in accordance with the laws of the Republic of Turkey, without regard to its conflict of law provisions. Any disputes arising from these Terms shall be resolved in the courts of Istanbul, Turkey.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">14. Changes to Terms</h2>
                  <p className="text-gray-600 mb-6">
                    We reserve the right to modify these Terms at any time. We will notify you of any material changes by posting the new Terms on this page and updating the "Last updated" date. Your continued use of the Services after such modifications constitutes your acceptance of the updated Terms.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mb-4">15. Contact Information</h2>
                  <p className="text-gray-600 mb-6">
                    If you have any questions about these Terms, please contact us at:
                  </p>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <p className="text-gray-700 font-semibold">CoachMeUpp</p>
                    <p className="text-gray-600">Email: bilgi@coachmeupp.com</p>
                    <p className="text-gray-600">Phone: +90 533 763 53 88</p>
                    <p className="text-gray-600">Location: Ankara, Turkey</p>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
